import React from 'react';

const NotFound = () => {
    return (
        <div className="w-full h-96">
            <h1 className="text-7xl text-red-600">NOT FOUND 404</h1>
        </div>
    );
};

export default NotFound;